import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1b4e75',
        secondary: '#7a7a89',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#ffffff',
      },
      dark: {
        primary: '#cc7a00',
        secondary: '#7a7a89',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#2b2b2b',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
